module.exports = __webpack_public_path__ + "ida_font02.jpg?492eeef4f71943c0a556ab31629aaee3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_font02.jpg
// module id = 69
// module chunks = 0